import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';

import { BaseUI } from '../base.ui';
import { Fee } from '../../domain/data';
import { FeeInterface, IdInterface, TypeDistributionInterface, ValidModelInterface } from '../../../core';
import { ParentEvents } from '../../utils/parent-events.service';

@Component({
    selector: 'thr-rate-form',
    templateUrl: './rate-form.component.html',
    styleUrls: ['./rate-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class RateFormComponent extends BaseUI implements AfterViewInit, OnChanges, OnDestroy {

    public isSelected = false;

    @Input()
    public data: FeeInterface = new Fee();

    @Input()
    public feedAmount = 0;

    @Input()
    public currentModelId: IdInterface;

    @Input()
    public currentModelName: string;

    @Input()
    public validModels: ValidModelInterface[] = [];

    @Input()
    public showInvestment = true;

    @Output()
    public changeDistributions: EventEmitter<TypeDistributionInterface[]> = new EventEmitter<TypeDistributionInterface[]>();

    @Output()
    public download: EventEmitter<IdInterface> = new EventEmitter<IdInterface>();

    @Output()
    public evaluateFee: EventEmitter<FeeInterface> = new EventEmitter<FeeInterface>();

    @Output()
    public currentSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (('data' in changes || 'validModels' in changes) && !!this.data && !!this.validModels.length) {
            this.onModelChange();
        }
    }

    public compareId(id1: IdInterface, id2: IdInterface): boolean {
        return !!id1 && !!id2 && id1?.equals(id2);
    }

    public onModelChange() {
        const validModel = this.validModels.find((it) => this.data.modelId?.equals(it.id));
        if (!!validModel) {
            this.changeDistributions.emit(validModel.distributions);
            if (!this.currentModelId || !validModel.id.equals(this.currentModelId)) {
                this.onEvaluateFee();
                this.isSelected = true;
                this.onCurrentSelected();
            }
        }
    }

    private onEvaluateFee() {
        this.evaluateFee.emit(this.data);
    }
    private onCurrentSelected() {
        this.currentSelected.emit(this.isSelected);
    }
    public onDownload() {
        this.download.emit(this.data.modelId);
    }
}
